import React from 'react';

function formatPrice(price) {
    if (price === null || price === undefined) return "R$ --";
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(price);
}

function DishCard({ dish, onDishClick }) {
    const { nome, imagem, preco, descricao, esgotado } = dish;

    return (
        <div 
            onClick={() => onDishClick(dish)}
            className="group flex flex-row items-stretch justify-between bg-white rounded-2xl p-3 md:p-4 shadow-sm hover:shadow-[0_10px_20px_-10px_rgba(82,138,137,0.3)] border border-[#dbcdac]/40 hover:border-[#528a89] transition-all duration-300 cursor-pointer w-full h-36 md:h-40"
        >
            {/* Esquerda: Textos */}
            <div className="flex flex-col justify-between flex-1 pr-3 md:pr-4 overflow-hidden">
                <div>
                    <h3 className="font-serif text-base md:text-lg font-bold text-stone-800 group-hover:text-[#528a89] transition-colors line-clamp-2 leading-tight">
                        {nome}
                    </h3>
                    <p className="text-xs md:text-sm text-stone-500 line-clamp-2 mt-1.5 leading-snug">
                        {descricao}
                    </p>
                </div>
                <div className="font-serif text-lg md:text-xl font-bold text-[#971253] mt-2">
                    {formatPrice(preco)}
                </div>
            </div>

            {/* Direita: Imagem Quadrada */}
            <div className="relative w-28 h-28 md:w-32 md:h-32 shrink-0 rounded-xl overflow-hidden bg-stone-100 self-center shadow-inner">
                <img 
                    src={imagem || '/images/placeholder.webp'} 
                    alt={nome} 
                    className={`w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 ${esgotado ? 'grayscale brightness-75' : ''}`}
                />
                
                {/* Badge Esgotado Moderno (Backdrop Blur) */}
                {esgotado && (
                    <div className="absolute inset-0 bg-black/30 backdrop-blur-[2px] flex items-center justify-center">
                        <span className="bg-red-600/90 text-white text-[10px] md:text-xs font-bold uppercase tracking-widest px-2 py-1 rounded shadow-md border border-white/20">
                            Esgotado
                        </span>
                    </div>
                )}
            </div>
        </div>
    );
}

export default DishCard;